import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputLabel,
  InputAdornment,
  IconButton,
  Button,
  Select,
  MenuItem,
  CircularProgress,
  Backdrop,
  ListItemText,
  ListItem,
  FormGroup,
} from "@material-ui/core";
import useStyles from "../../themes/style.js";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import moment from "moment";
import { Controller } from "react-hook-form";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { useNotification } from "../../hooks/useNotification.js";
import { Autocomplete } from "@material-ui/lab";
import { useHistory } from "react-router-dom";
import AddEmployeeSteps from "./AddEmployeeSteps.js";

const dividerClass = {
  marginTop: "20px",
};

const bloodGroups = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];

const maritalStatusList = [
  "Single",
  "Married",
  "Divorced",
  "Widowed",
  "Separated",
  "Prefer not to say",
];

const formInputFields = [
  {
    id: 1,
    label: "Basic Salary",
    placeholder: "Enter basicSalary",
    name: "basicSalary",
  },
  { id: 2, label: "HRA", placeholder: "Enter hra", name: "hra" },
  {
    id: 3,
    label: "HRA Arrears",
    placeholder: "Enter hraArrears",
    name: "hraArrears",
  },
  {
    id: 4,
    label: "Special Allowance",
    placeholder: "Enter specialAllowance",
    name: "specialAllowance",
  },
  {
    id: 5,
    label: "Shift Allowance",
    placeholder: "Enter shiftAllowance",
    name: "shiftAllowance",
  },
  {
    id: 6,
    label: "Shift Allowance Arrears",
    placeholder: "Enter shiftAllowanceArrears",
    name: "shiftAllowanceArrears",
  },
  {
    id: 7,
    label: "Other Allowance",
    placeholder: "Enter otherAllowance",
    name: "otherAllowance",
  },
  {
    id: 8,
    label: "Other Allowance Arrear",
    placeholder: "Enter otherAllowanceArrear",
    name: "otherAllowanceArrear",
  },
  {
    id: 9,
    label: "Telephone Allowance",
    placeholder: "Enter telephoneAllowance",
    name: "telephoneAllowance",
  },
  {
    id: 10,
    label: "Telephone Allowance Arrear",
    placeholder: "Enter telephoneAllowanceArrear",
    name: "telephoneAllowanceArrear",
  },
  {
    id: 11,
    label: "Conveyance",
    placeholder: "Enter conveyance",
    name: "conveyance",
  },
  {
    id: 12,
    label: "Conveyance Arrears",
    placeholder: "Enter conveyanceArrears",
    name: "conveyanceArrears",
  },
  {
    id: 13,
    label: "Medical Allowance",
    placeholder: "Enter medicalAllowance",
    name: "medicalAllowance",
  },
  {
    id: 14,
    label: "Medical Allowance Arrear",
    placeholder: "Enter medicalAllowanceArrear",
    name: "medicalAllowanceArrear",
  },
  {
    id: 15,
    label: "Basic Allowance",
    placeholder: "Enter basicAllowance",
    name: "basicAllowance",
  },
  {
    id: 16,
    label: "Basic Allowance Arrears",
    placeholder: "Enter basicAllowanceArrears",
    name: "basicAllowanceArrears",
  },
  { id: 17, label: "Bonus", placeholder: "Enter bonus", name: "bonus" },
  {
    id: 18,
    label: "Incentives",
    placeholder: "Enter incentives",
    name: "incentives",
  },
  {
    id: 19,
    label: "Other Earnings",
    placeholder: "Enter otherEarnings",
    name: "otherEarnings",
  },
  {
    id: 20,
    label: "Refund for Last Month Deduction",
    placeholder: "Enter refundForLastMonthDeduction",
    name: "refundForLastMonthDeduction",
  },
  { id: 21, label: "Arrears", placeholder: "Enter arrears", name: "arrears" },
  {
    id: 22,
    label: "Consultant",
    placeholder: "Enter consultant",
    name: "consultant",
  },
  {
    id: 23,
    label: "Consultant Arrears",
    placeholder: "Enter consultantArrears",
    name: "consultantArrears",
  },
  {
    id: 24,
    label: "Monthly Performance Arrears",
    placeholder: "Enter monthlyPerformanceArrears",
    name: "monthlyPerformanceArrears",
  },
  {
    id: 25,
    label: "Role Performance Bonus",
    placeholder: "Enter rolePerformanceBonus",
    name: "rolePerformanceBonus",
  },
  { id: 26, label: "PF", placeholder: "Enter pf", name: "pf" },
  { id: 27, label: "ESI", placeholder: "Enter esi", name: "esi" },
  { id: 28, label: "VPF", placeholder: "Enter vpf", name: "vpf" },
  {
    id: 29,
    label: "Income Tax",
    placeholder: "Enter incomeTax",
    name: "incomeTax",
  },
  { id: 30, label: "Loan", placeholder: "Enter loan", name: "loan" },
  { id: 31, label: "Others", placeholder: "Enter others", name: "others" },
  {
    id: 32,
    label: "Labour Welfare Fund",
    placeholder: "Enter labourWelfareFund",
    name: "labourWelfareFund",
  },
  {
    id: 33,
    label: "Salary Advance",
    placeholder: "Enter salaryAdvance",
    name: "salaryAdvance",
  },
  {
    id: 34,
    label: "Lunch Deduction",
    placeholder: "Enter lunchDeduction",
    name: "lunchDeduction",
  },
  {
    id: 35,
    label: "Other Deduction",
    placeholder: "Enter otherDeduction",
    name: "otherDeduction",
  },
  {
    id: 36,
    label: "Notice Period Deduction",
    placeholder: "Enter noticePeriodDeduction",
    name: "noticePeriodDeduction",
  },
  {
    id: 37,
    label: "Standard Deduction",
    placeholder: "Enter standardDeduction",
    name: "standardDeduction",
  },
  {
    id: 38,
    label: "Special Purpose Deduction",
    placeholder: "Enter specialPurposeDeduction",
    name: "specialPurposeDeduction",
  },
];

const AddEmployeeUser = () => {
  const classes = useStyles();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const handleNotificationCall = useNotification();

  const [values, setValues] = useState({
    showPassword: false,
  });
  const [userName, setUserName] = useState([]);
  const [loader, setLoader] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const handleDropdownChange = (e) => {
    console.log(e.target);
    const selectedOptions = e.target.value;
    // const selectedOptions = Array.from(e.target.value).map(
    //   (option) => option.value,
    // );
    setSelectedFields(selectedOptions);
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required("Email is required")
      .email("Email must be a Valid Email Address"),
    firstName: Yup.string()
      .max(255)
      .required("First Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "First Name be Alphanumeric",
      }),
    lastName: Yup.string()
      .max(255)
      .required("Last Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Last Name be Alphanumeric",
      }),
    mobile: Yup.string()
      .required("Mobile is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
    roleName: Yup.string().required("User Category is required"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters"),

    //employee schema
    dob: Yup.string(),
    gender: Yup.string().nullable().required("Gender is required"),
    bloodGroup: Yup.string().nullable().notRequired(),
    maritalStatus: Yup.string().nullable().notRequired(),
    spouseName: Yup.string().nullable().notRequired(),
    joinningDate: Yup.string()
      .required("Date of joining is required")
      .nullable(),
    personalEmail: Yup.string()
      .required("Personal Email is required")
      .email("Email must be a Valid Email Address"),

    fatherName: Yup.string().required("Father Name is required"),
    motherName: Yup.string().required("Mother Name is required"),
    emergencyMobile: Yup.string()
      .required("Emergency Contact Number is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
    emergencyContactRelation: Yup.string(),
    currentAddress: Yup.string().required("Current Address is required"),
    permanentAddress: Yup.string().required("Permanent Address is required"),
    totalExperience: Yup.string().required(
      "Total Experience field is required",
    ),

    empId: Yup.string().nullable().notRequired(),
    designation: Yup.string().nullable().notRequired(),
    department: Yup.string().nullable().notRequired(),
    companyBranchName: Yup.string().nullable(),
    DirectReportingTo: Yup.string(),
    DotReportingTo: Yup.string(),

    isContract: Yup.boolean()
      .required("This field is required")
      .oneOf([true, false], "Invalid value for isContract"),
    contractClientName: Yup.string().nullable().notRequired(),
    contractStartDate: Yup.string().when([], {
      is: () => isContract === true,
      then: Yup.string().required("Contract Start Date is required"),
      otherwise: Yup.string(),
    }),
    contractEndDate: Yup.string().when([], {
      is: () => isContract === true,
      then: Yup.string().required("Contract End Date is required"),
      otherwise: Yup.string(),
    }),
    contractType: Yup.string().nullable().notRequired(),
    contractDetails: Yup.string().nullable().notRequired(),

    aadhaarNumber: Yup.string().required("Aadhar Number is required"),
    panNumber: Yup.string().required("PAN Number is required"),
    pfNumber: Yup.string().nullable().notRequired(),
    uanNumber: Yup.string().nullable().notRequired(),
    esiNumber: Yup.string().nullable().notRequired(),
    bankName: Yup.string().nullable().notRequired(),
    bankAccountNumber: Yup.string().nullable().notRequired(),
    bankIfscCode: Yup.string().nullable().notRequired(),

    basicSalary: Yup.string().nullable(),
    specialAllowance: Yup.string().nullable(),
    shiftAllowance: Yup.string().nullable(),
    otherAllowance: Yup.string().nullable(),

    hra: Yup.string().nullable(),
    hraArrears: Yup.string().nullable(),
    shiftAllowanceArrears: Yup.string().nullable(),
    otherAllowanceArrear: Yup.string().nullable(),
    telephoneAllowance: Yup.string().nullable(),
    telephoneAllowanceArrear: Yup.string().nullable(),
    conveyance: Yup.string().nullable(),
    conveyanceArrears: Yup.string().nullable(),
    medicalAllowance: Yup.string().nullable(),
    medicalAllowanceArrear: Yup.string().nullable(),
    basicAllowance: Yup.string().nullable(),
    basicAllowanceArrears: Yup.string().nullable(),
    bonus: Yup.string().nullable(),
    incentives: Yup.string().nullable(),
    otherEarnings: Yup.string().nullable(),
    refundForLastMonthDeduction: Yup.string().nullable(),
    arrears: Yup.string().nullable(),
    consultant: Yup.string().nullable(),
    consultantArrears: Yup.string().nullable(),
    monthlyPerformanceArrears: Yup.string().nullable(),
    rolePerformanceBonus: Yup.string().nullable(),
    pf: Yup.string().nullable(),
    esi: Yup.string().nullable(),
    vpf: Yup.string().nullable(),
    incomeTax: Yup.string().nullable(),
    loan: Yup.string().nullable(),
    others: Yup.string().nullable(),
    labourWelfare: Yup.string().nullable(),
    fund: Yup.string().nullable(),
    salaryAdvance: Yup.string().nullable(),
    lunchDeduction: Yup.string().nullable(),
    otherDeduction: Yup.string().nullable(),
    noticePeriodDeduction: Yup.string().nullable(),
    standardDeduction: Yup.string().nullable(),
    specialPurposeDeduction: Yup.string().nullable(),
  });

  const {
    register,
    control,
    reset,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      isContract: false,
    },
  });

  useEffect(() => {
    getAllUserList();
  }, []);

  const getAllUserList = async () => {
    try {
      setLoader(true);

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}auth/getAllUserList`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.data;
        const userList = responseData.filter((item) => item.fullName !== null);
        setUserName(userList);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const isContract = watch("isContract");

  const handleAddEmployee = async (values) => {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/addUser`,
        {
          ...values,
          contractDurations: {
            contractStartDate: values.contractStartDate,
            contractEndDate: values.contractEndDate,
            contractClientName: values.contractClientName,
            contractType: values.contractType,
            contractDetails: values.contractDetails,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        history.push("/app/employees");
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };
  return (
    <>
    <div
      className={classes.flexCenter}
      style={{ padding: "30px 0px", width: "100%" }}
    >
      <div className="details-form-card employee-details-card">
        <div className="details-form-header">
          <span className="icon">
            <svg
              style={{ width: "1.3rem", height: "1.3rem" }}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V11H9C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H11V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H13V9ZM7.25007 2.38782C8.54878 2.0992 10.1243 2 12 2C13.8757 2 15.4512 2.0992 16.7499 2.38782C18.06 2.67897 19.1488 3.176 19.9864 4.01358C20.824 4.85116 21.321 5.94002 21.6122 7.25007C21.9008 8.54878 22 10.1243 22 12C22 13.8757 21.9008 15.4512 21.6122 16.7499C21.321 18.06 20.824 19.1488 19.9864 19.9864C19.1488 20.824 18.06 21.321 16.7499 21.6122C15.4512 21.9008 13.8757 22 12 22C10.1243 22 8.54878 21.9008 7.25007 21.6122C5.94002 21.321 4.85116 20.824 4.01358 19.9864C3.176 19.1488 2.67897 18.06 2.38782 16.7499C2.0992 15.4512 2 13.8757 2 12C2 10.1243 2.0992 8.54878 2.38782 7.25007C2.67897 5.94002 3.176 4.85116 4.01358 4.01358C4.85116 3.176 5.94002 2.67897 7.25007 2.38782Z"
                  fill="#FFFFFF"
                ></path>
              </g>
            </svg>
          </span>
          <p className="alert">Add Employee</p>
        </div>
        <div>
          <form
            onSubmit={handleSubmit(handleAddEmployee)}
            autoComplete="off"
            noValidate
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <FormControl className={classes.margin}>
                    <InputLabel shrink htmlFor="roleName">
                      Select User Category
                    </InputLabel>

                    <Controller
                      name="roleName"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <Select
                          value={value}
                          onChange={(e) => onChange(e.target.value)}
                          error={errors.gender ? true : false}
                          classes={{
                            root: classes.customSelectField,
                            icon: classes.customSelectIcon,
                          }}
                          disableUnderline
                        >
                          <MenuItem key="recruiter" value="RECRUITER">
                            Recruiter
                          </MenuItem>
                          <MenuItem
                            key="clientCoordinator"
                            value="CLIENTCOORDINATOR"
                          >
                            {decode.companyType === "COMPANY"
                              ? "Hiring Manager"
                              : "Client Coordinator"}
                          </MenuItem>
                          <MenuItem key="employee" value="EMPLOYEE">
                            Employee
                          </MenuItem>
                        </Select>
                      )}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.roleName?.message}
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>
              <Typography variant="body2" color="#818080">
                Personal Details
              </Typography>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="firstName">
                    First Name
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter First Name"
                      id="firstName"
                      name="firstName"
                      {...register("firstName")}
                      error={errors.firstName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.firstName?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="lastName">
                    Last Name
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      placeholder="Enter Last Name"
                      id="lastName"
                      name="lastName"
                      {...register("lastName")}
                      error={errors.lastName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.lastName?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="dob">
                    Date of Birth
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      size="small"
                      type="date"
                      placeholder="Select employee date of birth"
                      id="dob"
                      {...register("dob")}
                      error={errors.dob ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.dob?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="gender">
                    Gender
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <Controller
                      name="gender"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <Select
                          value={value}
                          onChange={(e) => onChange(e.target.value)}
                          error={errors.gender ? true : false}
                          classes={{
                            root: classes.customSelectField,
                            icon: classes.customSelectIcon,
                          }}
                          disableUnderline
                        >
                          <MenuItem value="Male">Male</MenuItem>
                          <MenuItem value="Female">Female</MenuItem>
                          <MenuItem value="Transgender">Transgender</MenuItem>
                          <MenuItem value="Prefer not to say">
                            Prefer not to say
                          </MenuItem>
                        </Select>
                      )}
                    />
                    <Typography variant="inherit" color="error">
                      {errors.gender?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="bloodGroup">
                    Blood Group
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <Controller
                      name="bloodGroup"
                      control={control}
                      defaultValue=""
                      render={({ field: { onChange, value } }) => (
                        <Select
                          value={value}
                          onChange={(e) => onChange(e.target.value)}
                          error={errors.bloodGroup ? true : false}
                          classes={{
                            root: classes.customTextField,
                            icon: classes.customSelectIcon,
                          }}
                          disableUnderline
                        >
                          {bloodGroups.map((group) => (
                            <MenuItem key={group} value={group}>
                              {group}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                    <Typography variant="inherit" color="error">
                      {errors.bloodGroup?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="maritalStatus">
                    Marital Status
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <Controller
                      name="maritalStatus"
                      control={control}
                      defaultValue=""
                      render={({ field: { onChange, value } }) => (
                        <Select
                          value={value}
                          onChange={(e) => onChange(e.target.value)}
                          error={errors.maritalStatus ? true : false}
                          classes={{
                            root: classes.customTextField,
                            icon: classes.customSelectIcon,
                          }}
                          disableUnderline
                        >
                          {maritalStatusList.map((group) => (
                            <MenuItem key={group} value={group}>
                              {group}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                    <Typography variant="inherit" color="error">
                      {errors.maritalStatus?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="spouseName">
                    Spouse Name
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Spouse Name"
                      name="spouseName"
                      {...register("spouseName")}
                      error={errors.spouseName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.spouseName?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="mobile">
                    Contact Number
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      type="number"
                      placeholder="Enter Mobile Number"
                      id="mobile"
                      name="mobile"
                      {...register("mobile")}
                      error={errors.mobile ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.mobile?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="joinningDate">
                    Date of Joining
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      size="small"
                      type="date"
                      placeholder="Select employee joining Date "
                      {...register("joinningDate")}
                      error={errors.joinningDate ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.joinningDate?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="personalEmail">
                    Personal Email
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      placeholder="Enter Persaonal Email"
                      name="personalEmail"
                      {...register("personalEmail")}
                      error={errors.personalEmail ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.personalEmail?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="fatherName">
                    Father Name
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Father Name"
                      name="fatherName"
                      {...register("fatherName")}
                      error={errors.fatherName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.fatherName?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="motherName">
                    Mother Name
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      placeholder="Enter Mother Name"
                      name="motherName"
                      {...register("motherName")}
                      error={errors.motherName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.motherName?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="emergencyMobile">
                    Emergency Contact Number
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      type="number"
                      placeholder="Enter Emergency Mobile Number"
                      id="emergencyMobile"
                      name="emergencyMobile"
                      {...register("emergencyMobile")}
                      error={errors.emergencyMobile ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.emergencyMobile?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="emergencyContactRelation">
                    Emergency Contact Name & Relationship
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      placeholder="Enter Emergency Contact Name & Relationship"
                      name="emergencyContactRelation"
                      {...register("emergencyContactRelation")}
                      error={errors.emergencyContactRelation ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.emergencyContactRelation?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="currentAddress">
                    Current Address
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Current Address"
                      name="currentAddress"
                      {...register("currentAddress")}
                      error={errors.currentAddress ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.currentAddress?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="permanentAddress">
                    Permanent Address
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      placeholder="Enter Permanent Address"
                      name="permanentAddress"
                      {...register("permanentAddress")}
                      error={errors.permanentAddress ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.permanentAddress?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="totalExperience">
                    Total Experience (in Years)
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Employee Total Experience"
                      name="totalExperience"
                      {...register("totalExperience")}
                      error={errors.totalExperience ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.totalExperience?.message}
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>

              <Typography variant="body2" color="#818080" style={dividerClass}>
                Office Details
              </Typography>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="email">
                    Official Email
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      placeholder="Enter Email"
                      id="email"
                      name="email"
                      {...register("email")}
                      error={errors.email ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.email?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="password">
                    Password
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      type={values.showPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      id="password"
                      InputProps={{
                        disableUnderline: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                            >
                              {values.showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      {...register("password")}
                      error={errors.password ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.password?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="empId">
                    Employee ID
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      type="number"
                      placeholder="Enter Employee Id"
                      id="empId"
                      name="empId"
                      {...register("empId")}
                      error={errors.employeeId ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.empId?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="companyBranchName">
                    Company Branch Name & Address
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Company Branch Name & Address"
                      name="companyBranchName"
                      {...register("companyBranchName")}
                      error={errors.companyBranchName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.companyBranchName?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="designation">
                    Designation
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Employee Designation"
                      name="designation"
                      {...register("designation")}
                      error={errors.designation ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.designation?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="department">
                    Department
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      placeholder="Enter Employee Department"
                      name="department"
                      {...register("department")}
                      error={errors.department ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.department?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="DirectReportingTo">
                    Direct Reporting To:
                  </InputLabel>
                  <Controller
                    name="DirectReportingTo"
                    control={control}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        className="filterFullWidth"
                        options={userName}
                        getOptionLabel={(option) => option.fullName}
                        onChange={(event, value) =>
                          setValue("DirectReportingTo", value ? value.id : null)
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label=""
                            InputLabelProps={{ shrink: true }}
                            type="text"
                          />
                        )}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="DotReportingTo">
                    Dotted Reporting To:
                  </InputLabel>
                  <Controller
                    name="DotReportingTo"
                    control={control}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        className="filterFullWidth"
                        options={userName}
                        getOptionLabel={(option) => option.fullName}
                        onChange={(event, value) =>
                          setValue("DotReportingTo", value ? value.id : null)
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label=""
                            InputLabelProps={{ shrink: true }}
                            type="text"
                          />
                        )}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="isContract">
                    Is a Contract with an Employer?
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <Controller
                      name="isContract"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <FormGroup row>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={value === true}
                                onChange={() => onChange(true)}
                              />
                            }
                            label="Yes"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={value === false}
                                onChange={() => onChange(false)}
                              />
                            }
                            label="No"
                          />
                        </FormGroup>
                      )}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.isContract?.message}
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>

              {isContract && (
                <>
                  <Typography
                    variant="body2"
                    color="#818080"
                    style={dividerClass}
                  >
                    Contract Details
                  </Typography>
                  <Grid container direction="row" spacing={2}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="contractClientName">
                        Contract Client Name
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Contract Client Name"
                          name="contractClientName"
                          {...register("contractClientName")}
                          error={errors.contractClientName ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.contractClientName?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="contractType">
                        Contract Type
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Contract Type"
                          name="contractType"
                          {...register("contractType")}
                          error={errors.contractType ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.contractType?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="contractDetails">
                        Contract Detail
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Contract Client Detail"
                          name="contractDetails"
                          {...register("contractDetails")}
                          error={errors.contractDetails ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.contractDetails?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="contractStartDate">
                        Contract Start Date
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          type="date"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Contract Start Date"
                          name="contractStartDate"
                          {...register("contractStartDate")}
                          error={errors.contractStartDate ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.contractStartDate?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="contractEndDate">
                        Contract End Date
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          type="date"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Contract End Date"
                          name="contractEndDate"
                          {...register("contractEndDate")}
                          error={errors.contractEndDate ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.contractEndDate?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                  </Grid>
                </>
              )}

              <Typography variant="body2" color="#818080" style={dividerClass}>
                KYC Details
              </Typography>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="aadhaarNumber">
                    Aadhaar Number
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      size="small"
                      placeholder="Enter Aadhaar Number"
                      name="aadhaarNumber"
                      {...register("aadhaarNumber")}
                      error={errors.aadhaarNumber ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.aadhaarNumber?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="panNumber">
                    PAN Number
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter PAN Number"
                      name="panNumber"
                      {...register("panNumber")}
                      error={errors.panNumber ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.panNumber?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="uanNumber">
                    UAN Number
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter UAN Number"
                      name="uanNumber"
                      {...register("uanNumber")}
                      error={errors.uanNumber ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.uanNumber?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="esiNumber">
                    ESI Number
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter ESI Number"
                      name="esiNumber"
                      {...register("esiNumber")}
                      error={errors.esiNumber ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.esiNumber?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="pfNumber">
                    PF Number
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter PF Number"
                      name="pfNumber"
                      {...register("pfNumber")}
                      error={errors.pfNumber ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.pfNumber?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="bankName">
                    Bank Name
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Bank Name"
                      name="bankName"
                      {...register("bankName")}
                      error={errors.bankName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.bankName?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="bankAccountNumber">
                    Bank Account Number
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Bank Account Number"
                      name="bankAccountNumber"
                      {...register("bankAccountNumber")}
                      error={errors.bankAccountNumber ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.bankAccountNumber?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="bankIfscCode">
                    Bank IFSC Code
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Bank IfscCode"
                      name="bankIfscCode"
                      {...register("bankIfscCode")}
                      error={errors.bankIfscCode ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.bankIfscCode?.message}
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>

              <Typography variant="body2" color="#818080" style={dividerClass}>
                Payslip Details
              </Typography>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="basicSalary">
                    Basic Salary
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      type="number"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Basic Salary"
                      name="basicSalary"
                      {...register("basicSalary")}
                      error={errors.basicSalary ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.basicSalary?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="formField">
                    Select Fields
                  </InputLabel>

                  <Select
                    multiple
                    onChange={handleDropdownChange}
                    value={selectedFields}
                    classes={{
                      root: classes.customTextField,
                      icon: classes.customSelectIcon,
                    }}
                    disableUnderline
                    renderValue={(selected) =>
                      selected
                        .map((value) => {
                          const selectedItem = formInputFields.find(
                            (field) => field.name === value,
                          );
                          return selectedItem ? selectedItem.label : value;
                        })
                        .join(", ")
                    }
                  >
                    {formInputFields.map((field) => (
                      <MenuItem key={field.id} value={field.name}>
                        {/* <ListItem button>
                    
                          <Checkbox
                            checked={selectedFields.indexOf(field.name) > -1}
                          />
                          <ListItemText primary={field.label} />
                        </ListItem> */}
                        <Checkbox
                          checked={selectedFields.indexOf(field.name) > -1}
                        />
                        {field.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {selectedFields.map((fieldName) => {
                  const field = formInputFields.find(
                    (f) => f.name === fieldName,
                  );
                  return (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor={field?.name}>
                        {field?.label}
                      </InputLabel>

                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder={field?.placeholder}
                          name={field?.name}
                          {...register(field.name)}
                          // error={errors.field.name ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors[field.name]?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                  );
                })}

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="specialAllowance">
                    Special Allowance
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      type="number"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Special Allowance"
                      name="specialAllowance"
                      {...register("specialAllowance")}
                      error={errors.specialAllowance ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.specialAllowance?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel shrink htmlFor="shiftAllowance">
                    Shift Allowance
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      type="number"
                      classes={{ root: classes.customTextField }}
                      InputProps={{ disableUnderline: true }}
                      placeholder="Enter Shift Allowance"
                      name="shiftAllowance"
                      {...register("shiftAllowance")}
                      error={errors.shiftAllowance ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.shiftAllowance?.message}
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>
            </div>
            <Grid
              container
              direction="row"
              spacing={2}
              style={{
                padding: "24px 10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Button
                style={{ minWidth: "300px" }}
                variant="contained"
                color="primary"
                size="small"
                disabled={isSubmitting}
                type="submit"
              >
                Save
              </Button>
              <Button
                style={{ minWidth: "300px" }}
                variant="contained"
                size="small"
                color="secondary"
                onClick={() => history.push("/app/employees")}
              >
                cancel
              </Button>
            </Grid>
          </form>
        </div>
      </div>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
    </>
  );
};

export default AddEmployeeUser;
